import { useMemo } from 'react';

// hooks
import { merge } from 'lodash';

// components
import { MentionsInputStyle, MentionsInputProps } from 'react-mentions';
import MemberMention from './MemberMention';

// styles
import theme from 'assets/theme';
import { makeStyles } from '@material-ui/core/styles';

export type MentionsInputBaseProps = Omit<MentionsInputProps, 'children'> & {
  multiline?: boolean;
};

export default function MentionsInputBase({
  value,
  style,
  multiline = false,
  a11ySuggestionsListLabel = 'Suggested people to mention',
  ...rest
}: MentionsInputBaseProps) {
  const classes = useStyles();

  const inputStyle = useMemo(
    () => merge({}, mentionsInputStyle, multiline ? multilineStyle : {}, style),
    [multiline, style]
  );

  return (
    <MemberMention
      value={value || ''}
      className={classes.highlighterSpan}
      style={inputStyle}
      a11ySuggestionsListLabel={a11ySuggestionsListLabel}
      {...rest}
    />
  );
}

const useStyles = makeStyles(() => ({
  highlighterSpan: { '& span': { visibility: 'visible !important' } },
}));
const mentionsInputStyle: MentionsInputStyle = {
  lineHeight: 1.5,
  input: {
    overflow: 'hidden',
    color: 'transparent',
    border: 'none',
    outline: 'none',
    padding: 0,
    caretColor: theme.palette.text.primary,
  },
  highlighter: {
    color: theme.palette.text.primary,
    boxSizing: 'border-box',
    height: 'auto',
    minHeight: '1.5em',
    padding: 0,
    wordBreak: 'break-word',
  },
  suggestions: {
    zIndex: 2,
    item: {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.default,
      padding: '8px 16px',
      '&focused': {
        backgroundColor: theme.palette.secondary.dark,
      },
    },
  },
};
const multilineStyle: MentionsInputStyle = {
  input: {
    overflow: 'auto',
    padding: '16.5px 14px',
  },
  highlighter: {
    height: 100,
    padding: '16.5px 14px',
  },
};
